'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = null;

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL), function (currentChannel, action) {
  return currentChannel || (0, _threadGetters.getChannel)(action.payload);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.INITIALIZE_VISITOR_ONLINE_CHANNEL, ActionTypes.SET_CURRENT_CHANNEL), function (currentChannel, action) {
  return action.payload.channel;
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.SET_THREAD_FILTER, ActionTypes.SET_SEARCH_TEXT, ActionTypes.CLEAR_CURRENT_CHANNEL), function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/current-channel/reducers/currentChannel.js
// module id = 878
// module chunks = 2 3